import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@material-ui/core';
import { Button } from '../buttons';

type Props = {
  onClose: () => void;
  title: string;
  message: string;
};

const ImageUploadFailedDialog: FC<Props> = ({ onClose, title, message }) => {
  const { t } = useTranslation();

  return (
    <Dialog open={true} onClose={onClose}>
      <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">{message}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          {t('shared.ok')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ImageUploadFailedDialog;
